import React from 'react';
import { Route, Router, Switch } from 'dva/router';
import BaseLayout from '@src/components/pc-layout';
import NotFound from '@src/pages/not-found';
import Main from '@src/pages/main';

import './index.less';
export const routeName = {
  MAIN: '/',
  NOT_FOUND: '/404'
};

class ChildApp extends React.Component {
  render() {
    const { history } = this.props;
    return (
      <BaseLayout>
        <Router history={history}>
          <Switch>
            <Route path={routeName.MAIN} component={Main} />
            <Route
              exact
              path="/doc"
              render={() => {
                window.location.href = GIT_ADDRESS;
                return null;
              }}
            />
            <Route path={routeName.NOT_FOUND} component={NotFound} />
          </Switch>
        </Router>
      </BaseLayout>
    );
  }
}

function App(props) {
  return <ChildApp {...props} />;
}

export default App;



// WEBPACK FOOTER //
// ./src/pages/app/index.js